<template>
  <div class="top-title-container">
      <div class="container">
        <h3 class="top-title">{{data.t}}</h3>
        <span class="top-cross"></span>
        <p class="top-subtitle" :class='isSearch?"d-none":"" ' >{{data.st}}</p>
        <slot></slot>
      </div>
    </div>
</template>
<script>
  import topTitleCN from '../data/CN/topTitle_CN.json'
  import topTitleEN from '../data/EN/topTitle_EN.json'
  import topTitleJP from '../data/JP/topTitle_JP.json'
export default {
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, required: true },
    isSearch: { type: Boolean }
  },
  data() {
    return {
      currentLanguage: '', // 当前语言
      data: {
        t: "",
        st: ""
      }
    }
  },
  mounted() {
    const _this = this
    window.addEventListener('setItemEvent', function(e) {
        // e.key : 是值发生变化的key
        // 例如 e.key==="token";
        // e.newValue : 是可以对应的新值
        if (e.key === 'language') {
            _this.currentLanguage = e.newValue
            var d = e.newValue
            _this.init(d)
        }
    })
  },
  methods: {
    init(e) {
      for (var i = 0; i < topTitleCN.length; i++) {
        if (topTitleCN[i].title == this.title) {
          if (e === 'CN') {
            this.data.t = topTitleCN[i].title
            this.data.st = topTitleCN[i].subtitle
          } else if (e === 'EN') {
            this.data.t = topTitleEN[i].title
            this.data.st = topTitleEN[i].subtitle
          } else if (e === 'JP') {
            this.data.t = topTitleJP[i].title
            this.data.st = topTitleJP[i].subtitle
          }
        }
      }
    }
  },
  created() {
   var language = localStorage.getItem('language')
   this.currentLanguage = language
   this.init(language)
  }
}
</script>
<style scoped>
.top-title-container {
  width: 100%;
  padding: 30px 0;
  text-align: center;
  background: url('../assets/image/top-bg.png') center no-repeat;
}
.top-title {
  font-size: 30px;
  
  color: #fff;
  margin: 0;
  line-height: 30px;
}
.top-cross {
  display: inline-block;
  width: 36px;
  height: 3px;
  background-color: #f04c05;
}
.top-subtitle {
  font-size: 18px;
  color: #fff;
  margin-top: 6px;
}
</style>